<template>
  <div class="team-project">
    <div class="team-project-title">{{ $t('teamProject.title') }}</div>
    <div class="table-center">
      <el-row class="filter-row">
        <!-- 组别筛选（运动员表单配置显示组别时才展示） -->
        <el-col :span="4" v-if="showGroupFilter">
          <el-select v-model="params.competitionGroupId" :placeholder="$t('common.pleaseSelect') + ' ' + $t('common.group')" style="width: 90%" clearable filterable>
            <el-option v-for="item in groupOptions" :key="item.id" :label="localeValue(item, groupNameKey)" :value="item.id"/>
          </el-select>
        </el-col>
        <!-- 小项筛选（运动员表单配置显示小项时才展示，未配置时默认展示） -->
        <el-col :span="4" v-if="showItemFilter">
          <el-select v-model="params.competitionItemId" :placeholder="$t('common.pleaseSelect') + ' ' + $t('common.item')" style="width: 90%" clearable filterable>
            <el-option v-for="item in itemOptions" :key="item.id" :label="localeValue(item, itemNameKey)" :value="item.id"/>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="findProjectList">{{ $t('common.search') }}</el-button>
          <el-button @click="emptyParams">{{ $t('common.reset') }}</el-button>
        </el-col>
      </el-row>
      <div class="table-body">
        <el-table :data="projectList" :border="true" height="100%">
        <el-table-column type="index" :label="$t('common.serialNo')" width="50" :fixed="true"></el-table-column>
        <el-table-column prop="nameCh" :label="$t('common.project')" width="200" :fixed="true">
          <template slot-scope="scope">
            {{localeValue(scope.row, projectNameKey)}}
          </template>
        </el-table-column>
        <el-table-column prop="teamAthleteList" :label="$t('common.athlete')">
          <template slot-scope="scope">
            <span v-for="(item, index) in scope.row.teamAthleteList" :key="item.id" style="width: 100%">
              <span v-if="index === 0">{{localeValue(item, competitionAthleteNameKey)}}</span>
              <span v-else>、{{localeValue(item, competitionAthleteNameKey)}}</span>
              <span v-if="localeValue(item, itemPositionNameKey)">（{{ $t('common.position') }}：{{ localeValue(item, itemPositionNameKey) }}）</span>
              <span v-if="item.substitution === 1">（{{ $t('common.substitute') }}）</span>
            </span>
            <span v-if="scope.row.teamAthleteList[0] && scope.row.teamAthleteList[0].description">（{{ remarkLabel }}：{{ scope.row.teamAthleteList[0].description}}）</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('common.operation')" width="100">
          <template slot-scope="scope">
            <el-button @click="handleEditAthlete(scope.row)" type="text" :disabled="isTeamSubmitted">{{ $t('teamProject.editProject') }}</el-button>
          </template>
        </el-table-column>
        </el-table>
      </div>
    </div>

    <!--  编辑报项  -->
    <el-dialog :title="$t('teamProject.editProject')" :visible.sync="athleteFormVisible" width="700px"
               lock-scroll :close-on-click-modal="false">
      <el-form ref="athleteDataForm" :model="athleteDataForm" :rules="athleteRuleForm" v-loading="athleteFormLoading" label-width="200px">
        <el-form-item :label="$t('common.athlete')">
          <div class="athlete-checked" v-for="item in athleteList" :key="item.id">
            <el-checkbox :label="item.id" v-model="item.athleteCheck" :disabled="!!occupiedAthleteMap[item.id]">{{localeValue(item, athleteNameKey)}}</el-checkbox>
            <span class="athlete-occupied" v-if="occupiedAthleteMap[item.id]">已报：{{ occupiedAthleteMap[item.id] }}</span>
            <el-checkbox :label="item.id" v-model="item.substitutionCheck" v-if="item.athleteCheck && item.substitution">{{ $t('common.substitute') }}</el-checkbox>
            <!-- 报项职位：小项需要职位且已配置职位时显示，达到限制人数的职位禁用 -->
            <el-select v-if="positionRequired && item.athleteCheck" v-model="item.itemPositionId"
                       :placeholder="$t('teamProject.selectPosition')" clearable filterable style="width: 160px; margin-left: 10px">
              <el-option v-for="position in positionList" :key="position.id" :label="localeValue(position, positionNameKey)" :value="position.id"
                         :disabled="isPositionDisabled(position, item)"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item v-if="remarkRequired" :label="remarkLabel" prop="description"
                      :rules="hasCheckedAthlete ? [{required: true, message: remarkPlaceholder, trigger: 'blur'}] : []">
          <el-input v-model="athleteDataForm.description" type="textarea" :placeholder="$t('common.pleaseInput')"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="athleteFormVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" :loading="athleteBtnLoading" @click="handleEditAthleteSubmit()">{{ $t('common.ok') }}</el-button>
    </span>
    </el-dialog>
  </div>
</template>
<script>
import {getAthleteListTeamProject} from "@/api/athlete";
import {listTeamProject} from "@/api/competitionProject";
import {listTeamByProjectId, saveTeamProject} from "@/api/athleteProject";
import {competitionItemPositionListReg} from "@/api/itemPosition";
import {getCompetitionGroupList} from "@/api/competitionGroup";
import {getCompetitionItemList} from "@/api/competitionItem";
export default {
  name: "team-project",
  props: {
    teamInfo: {
      type: Object,
      required: true
    },
    competitionFormConfigInfo: {
      type: Object,
      default: function () {
        return {
          id: '',
          competitionId: '',
          teamForm: {},
          athleteForm: {},
          personForm: {},
          summaryForm: {}
        }
      }
    }
  },
  computed: {
    // 项目名称中英文
    projectNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 运动员姓名中英文
    athleteNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'realNameCh' : 'realNameEn';
    },
    // 赛事运动员姓名中英文
    competitionAthleteNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'athleteRealNameCh' : 'athleteRealNameEn';
    },
    // 职位名称中英文
    positionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 申报列表运动员所选职位名称中英文
    itemPositionNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'itemPositionNameCh' : 'itemPositionNameEn';
    },
    // 组别名称中英文
    groupNameKey(){
      return this.$i18n.locale === 'zh-CN' ? 'nameCh' : 'nameEn';
    },
    // 小项名称中英文
    itemNameKey() {
      return this.$i18n.locale === 'en' ? 'nameEn' : 'nameCh';
    },
    // 组别筛选是否展示（运动员表单配置显示组别时才展示）
    showGroupFilter() {
      const fieldConfig = (this.competitionFormConfigInfo.athleteForm || {}).groupJson;
      return !!(fieldConfig && fieldConfig.isShow === 1);
    },
    // 小项筛选是否展示（运动员表单配置显示小项时才展示，未配置时默认展示兼容历史数据）
    showItemFilter() {
      const fieldConfig = (this.competitionFormConfigInfo.athleteForm || {}).itemJson;
      return fieldConfig ? fieldConfig.isShow === 1 : true;
    },
    // 备注标题（报项表单配置，留空默认备注）
    remarkLabel() {
      const remarkLabel = (this.competitionFormConfigInfo.projectForm || {}).remarkLabel;
      return remarkLabel || this.$t('common.comment');
    },
    // 备注输入提示
    remarkPlaceholder() {
      return this.$t('common.pleaseInput') + this.remarkLabel;
    },
    // 当前项目
    currentProject() {
      return this.projectList.find(item => item.id === this.athleteDataForm.projectId);
    },
    // 当前编辑项目同小项其他项目已报运动员（athleteId → 项目名称）
    occupiedAthleteMap() {
      const project = this.currentProject;
      if (!project || !project.competitionItemId) {
        return {};
      }
      const map = {};
      this.projectList.forEach(item => {
        if (item.id === project.id || item.competitionItemId !== project.competitionItemId) {
          return;
        }
        (item.teamAthleteList || []).forEach(athlete => {
          if (athlete.athleteId != null) {
            map[athlete.athleteId] = this.localeValue(item, this.projectNameKey);
          }
        });
      });
      return map;
    },
    // 项目是否要求填写备注
    remarkRequired() {
      return !!(this.currentProject && this.currentProject.isRemark === 1);
    },
    // 是否已勾选运动员（勾选了运动员备注才必填；全部取消勾选保存视为删除报项）
    hasCheckedAthlete() {
      return this.athleteList.some(item => item.athleteCheck);
    },
  },
  data() {
    return {
      // 项目列表
      projectList: [],
      // 查询条件
      params: {
        competitionGroupId: '',
        competitionItemId: ''
      },
      // 组别选项
      groupOptions: [],
      // 小项选项
      itemOptions: [],
      // 编辑运动员表单
      athleteFormVisible: false,
      // 编辑运动员表单加载loading
      athleteFormLoading: false,
      // 编辑运动员表单确定loading
      athleteBtnLoading: false,
      // 编辑运动员表单
      athleteDataForm: {
        projectId: '',
        description: ''
      },
      // 运动员列表
      athleteList: [],
      // 报项职位列表（当前项目所属小项）
      positionList: [],
      // 当前编辑项目是否需要选择职位
      positionRequired: false,
      athleteRuleForm: {
        athleteCheck: [
          {required: true, message: this.$t('validate.requiredSelect'), trigger: 'blur'},
        ],
      }
    };
  },
  created() {let id = this.$route.query.id;
    if (!id) {
      this.$router.push({ path: "/index" });
    } else {
      this.competitionId = id;
    }
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login?id=" + this.competitionId });
    } else {
      this.findProjectList();
      this.findFilterOptions();
    }
  },
  destroyed() {},
  methods: {
    // 筛选选项（组别按运动员表单配置的组别级别过滤且仅在显示组别时加载，小项按运动员表单配置的小项级别过滤）
    findFilterOptions(){
      if (this.showGroupFilter) {
        const groupLevel = ((this.competitionFormConfigInfo.athleteForm || {}).groupJson || {}).groupLevel;
        getCompetitionGroupList({competitionId: this.competitionId, level: groupLevel || ''}).then((res) => {
          if (res.code === 200) {
            this.groupOptions = res.data.list;
          }
        });
      }
      if (this.showItemFilter) {
        const itemLevel = ((this.competitionFormConfigInfo.athleteForm || {}).itemJson || {}).groupLevel;
        getCompetitionItemList({competitionId: this.competitionId, level: itemLevel || ''}).then((res) => {
          if (res.code === 200) {
            this.itemOptions = res.data.list;
          }
        });
      }
    },
    // 项目列表
    findProjectList(){
      let params = {
        competitionId: this.competitionId,
        projectType: 2,
        competitionGroupId: this.params.competitionGroupId,
        competitionItemId: this.params.competitionItemId
      }
      listTeamProject(params).then((res) => {
        if (res.code === 200) {
          this.projectList = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 重置
    emptyParams() {
      this.params.competitionGroupId = '';
      this.params.competitionItemId = '';
      this.findProjectList();
    },
    // 运动员列表（优先按项目可参赛组别集合查询，未配置时按项目所属组别）
    findAthleteList(row){
      this.athleteList = [];
      let params = {
        competitionId: this.competitionId
      }
      const groupIds = row.participantGroupIds ? String(row.participantGroupIds).split(',').map(Number).filter(id => !isNaN(id)) : [];
      if (groupIds.length > 0) {
        // 逗号分隔字符串传递，避免 axios 数组默认序列化成 groupIds[]= 导致后端绑定报错
        params.groupIds = groupIds.join(',');
      } else if (row.competitionGroupId) {
        params.groupId = row.competitionGroupId;
      }
      return getAthleteListTeamProject(params).then((res) => {
        if (res.code === 200) {
          let athleteList = res.data.list;
          if (athleteList.length > 0) {
            let newAthleteList = [];
            for (let i = 0; i < athleteList.length; i++) {
              let athleteObj = athleteList[i];
              newAthleteList.push({
                id: athleteObj.id,
                realNameCh: athleteObj.realNameCh,
                realNameEn: athleteObj.realNameEn,
                substitution: athleteObj.substitution,
                sortCode: athleteObj.sortCode,
                itemPositionId: null,
                athleteCheck: false,
                substitutionCheck: false
              })
            }
            this.athleteList = newAthleteList;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 报项职位配置：项目需要职位（positionCheck=1，取所属小项配置）且该赛事+小项下已配置职位时，编辑报项才出现职位选择
    async findPositionList(projectId){
      this.positionRequired = false;
      this.positionList = [];
      const projectObj = this.projectList.find(item => item.id === projectId);
      if (!projectObj || !projectObj.competitionItemId || projectObj.positionCheck !== 1) return;
      const res = await competitionItemPositionListReg({competitionId: this.competitionId, competitionItemId: projectObj.competitionItemId});
      if (res.code === 200 && res.data.list && res.data.list.length > 0) {
        this.positionList = res.data.list;
        this.positionRequired = true;
      }
    },
    // 职位是否已被占满：限制人数的职位，其他已勾选运动员占用数达到上限时禁用
    isPositionDisabled(position, athlete){
      if (position.numCheck !== 1) return false;
      let count = 0;
      for (const a of this.athleteList) {
        if (a.id !== athlete.id && a.athleteCheck && a.itemPositionId === position.id) {
          count++;
        }
      }
      return count >= position.numEndValue;
    },
    // 编辑报项表单
    async handleEditAthlete(row){
      this.athleteDataForm.projectId = row.id || '';
      this.athleteFormVisible = true;
      await Promise.all([this.findAthleteList(row), this.findPositionList(row.id)]);
      this.$nextTick(() => {
        this.$refs['athleteDataForm'].resetFields();
        // 防止残留上一次编辑的备注
        this.athleteDataForm.description = '';
        if (row.id) {
          let params = {
            competitionId: this.competitionId,
            projectId: row.id,
            projectType: 2
          }
          listTeamByProjectId(params).then((res) => {
            if (res.code === 200) {
              let teamProjectList = res.data.list;
              let athleteList = this.athleteList;
              let newAthleteList = [];
              for (let i = 0; i < athleteList.length; i++) {
                let athleteObj = athleteList[i];
                let teamProjectObj = teamProjectList.find(item => item.athleteId === athleteObj.id);
                if (teamProjectObj) {
                  athleteObj.athleteCheck = true;
                  athleteObj.substitutionCheck = teamProjectObj.substitution === 1;
                  athleteObj.itemPositionId = teamProjectObj.itemPositionId || null;
                  // 回显备注（同一项目共用一条备注）
                  this.athleteDataForm.description = teamProjectObj.description;
                }
                newAthleteList.push(athleteObj);
              }
              this.athleteList = newAthleteList;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.athleteDataForm.competitionId = this.competitionId;
        }
      })
    },
    // 编辑报项提交
    handleEditAthleteSubmit(){
      // 项目要求备注且已勾选运动员时必填（未勾选运动员保存视为删除报项）
      if (this.remarkRequired && this.hasCheckedAthlete && !(this.athleteDataForm.description || '').trim()) {
        return this.$message.warning(this.remarkPlaceholder);
      }
      let athleteList = this.athleteList;
      let checkAthleteList = athleteList.filter(item => item.athleteCheck);
      // 需要职位的项目：每个已勾选运动员必须选择职位
      if (this.positionRequired) {
        for (const athleteObj of checkAthleteList) {
          if (!athleteObj.itemPositionId) {
            return this.$message.warning(this.$t('teamProject.pleaseSelectPosition'));
          }
        }
      }
      let teamAthleteList = [];
      for (let i = 0; i < checkAthleteList.length; i++) {
        let athleteObj = checkAthleteList[i];
        teamAthleteList.push({
          athleteId: athleteObj.id,
          itemPositionId: athleteObj.itemPositionId || null,
          substitution: athleteObj.substitutionCheck ? 1 : 0,
          sortCode: this.athleteDataForm.projectId
        })
      }
      let dataForm = {
        teamId: this.teamInfo.id,
        projectId: this.athleteDataForm.projectId,
        description: this.athleteDataForm.description,
        teamAthleteList: teamAthleteList
      }
      this.athleteBtnLoading = true;
      saveTeamProject(this.competitionId, dataForm).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg);
          this.findProjectList();
          this.athleteBtnLoading = false;
          this.athleteFormVisible = false;
        } else {
          this.$message.error(res.msg);
          this.athleteBtnLoading = false;
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.team-project{
  width: 100%;

  .team-project-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    padding-bottom: 12px;
    margin-bottom: 20px;
    border-bottom: 2px solid #1E50AE;
  }

  .table-center {
    height: calc(100vh - 300px);
    margin-top: 10px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    padding: 16px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;

    .filter-row {
      flex-shrink: 0;
      margin-bottom: 10px;
    }

    .table-body {
      flex: 1;
      height: 0;
      min-height: 0;
      overflow: hidden;

      ::v-deep .el-table {
        height: 100%;
      }
    }
  }

  ::v-deep .el-table th {
    background-color: #f0f2f5;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }

  ::v-deep .el-table .el-table__row:hover > td {
    background-color: #ecf5ff;
  }
}

.athlete-occupied {
  color: #909399;
  font-size: 12px;
  margin-left: 8px;
}
</style>
